import { render, staticRenderFns } from "./DAOdontogramHistory.vue?vue&type=template&id=637ab98c&scoped=true"
import script from "./DAOdontogramHistory.vue?vue&type=script&lang=js"
export * from "./DAOdontogramHistory.vue?vue&type=script&lang=js"
import style0 from "./DAOdontogramHistory.vue?vue&type=style&index=0&id=637ab98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ab98c",
  null
  
)

export default component.exports